var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('salesChart'),_c('purchaseChart'),_c('transactionChart'),_c('depositeChart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }